export type CompatibilityTableType = 'lpn' | 'vin' | 'ddd' | 'vehicleInfo';

export type CompatibilityColumn =
  | 'plate'
  | 'vin'
  | 'brand'
  | 'model'
  | 'reg'
  | 'calibration'
  | 'tachograph'
  | 'firmware'
  | 'generation'
  | 'eets'
  | 'gnss'
  | 'live'
  | 'remote'
  | 'action';

export const compatibilityTableColumns: Record<CompatibilityTableType, CompatibilityColumn[]> = {
  lpn: ['plate', 'brand', 'model', 'tachograph', 'firmware', 'eets', 'gnss', 'live', 'remote'],
  vin: ['vin', 'brand', 'model', 'tachograph', 'firmware', 'eets', 'gnss', 'live', 'remote'],
  ddd: ['vin', 'tachograph', 'firmware', 'generation', 'eets', 'gnss', 'live', 'remote'],
  vehicleInfo: [
    'brand',
    'model',
    'reg',
    'calibration',
    'tachograph',
    'firmware',
    'eets',
    'gnss',
    'live',
    'remote',
    'action'
  ]
};

export const compatibilityStatusColumns: CompatibilityColumn[] = ['eets', 'gnss', 'live', 'remote'];
